export default "__VITE_ASSET__CaWQoxoR__"